var map = {
	"./xinxi#00a859.png": "f7aa",
	"./xinxi#1296db.png": "26c9",
	"./xinxi#d81e06.png": "9417",
	"./xinxi.png": "1dc3",
	"./xinxi0.png": "75d5",
	"./xinxi1.png": "4d90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb3a";